import React, { useContext } from "react";
import Widget from "../components/Widget/Widget";
import { WidgetContext } from "../store/widgetContext";
import { useWidgetData } from "../hooks/useWidgetData";

/**
 * Layout: thin shell that runs widget data side effects (useWidgetData)
 * and renders Widget + Launcher (children) when not collapsed.
 */
const Layout = (props) => {
	const { children } = props;
	useWidgetData(props);
	const { collapsed } = useContext(WidgetContext);

	return (
		<>
			{!collapsed && <Widget {...props} />}
			{children}
		</>
	);
};

export default Layout;
